/* ============================================================
   CLEAR CHRONIC — theme.js
   AJAX cart + drawer, mobile nav, PDP option selectors, gallery.
   Works against Shopify's /cart AJAX API. Degrades gracefully
   on the static preview (no /cart endpoint) by faking state.
   ============================================================ */
(function () {
  "use strict";

  const money = (cents) =>
    "$" + (cents / 100).toLocaleString("en-US", { minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 });

  const FREE_SHIP_THRESHOLD = window.CC_FREE_SHIP || 15000; // cents

  /* ---------- Drawer open/close ---------- */
  const overlay = document.querySelector(".drawer-overlay");
  const drawer  = document.getElementById("cart-drawer");

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add("is-open");
    overlay.classList.add("is-open");
    document.body.style.overflow = "hidden";
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    overlay.classList.remove("is-open");
    document.body.style.overflow = "";
  }

  document.addEventListener("click", (e) => {
    if (e.target.closest("[data-cart-toggle]")) { e.preventDefault(); openDrawer(); }
    if (e.target.closest("[data-cart-close]") || e.target === overlay) closeDrawer();
  });
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") { closeDrawer(); closeMobileNav(); } });

  /* ---------- Mobile nav ---------- */
  const mnav = document.getElementById("mobile-nav");
  function closeMobileNav(){ mnav && mnav.classList.remove("is-open"); document.body.style.overflow=""; }
  document.addEventListener("click", (e) => {
    if (e.target.closest("[data-mnav-open]")) { mnav.classList.add("is-open"); document.body.style.overflow="hidden"; }
    if (e.target.closest("[data-mnav-close]")) closeMobileNav();
  });

  /* ---------- Cart rendering ---------- */
  function renderShipMeter(subtotal) {
    const label = document.querySelector("[data-ship-label]");
    const fill  = document.querySelector("[data-ship-fill]");
    if (!fill) return;
    const pct = Math.min(100, (subtotal / FREE_SHIP_THRESHOLD) * 100);
    fill.style.width = pct + "%";
    if (label) {
      if (subtotal >= FREE_SHIP_THRESHOLD) label.textContent = "Free shipping unlocked";
      else label.textContent = money(FREE_SHIP_THRESHOLD - subtotal) + " away from free shipping";
    }
  }

  function updateCartCounts(count) {
    document.querySelectorAll("[data-cart-count]").forEach((el) => (el.textContent = count));
  }

  async function refreshCart() {
    let cart;
    try {
      const res = await fetch("/cart.js", { headers: { Accept: "application/json" } });
      cart = await res.json();
    } catch (_) { return; } // static preview — no endpoint
    paintCart(cart);
  }

  function paintCart(cart) {
    updateCartCounts(cart.item_count);
    const countEl = document.querySelector("[data-drawer-count]");
    if (countEl) countEl.textContent = cart.item_count + (cart.item_count === 1 ? " item" : " items");

    renderShipMeter(cart.total_price);

    const sub = document.querySelector("[data-cart-subtotal]");
    if (sub) sub.textContent = money(cart.total_price);
    const checkoutTotal = document.querySelector("[data-checkout-total]");
    if (checkoutTotal) checkoutTotal.textContent = money(cart.total_price);

    const list = document.querySelector("[data-cart-items]");
    const empty = document.querySelector("[data-cart-empty]");
    const foot = document.querySelector("[data-cart-foot]");
    if (!list) return;

    if (cart.item_count === 0) {
      list.innerHTML = "";
      if (empty) empty.hidden = false;
      if (foot) foot.hidden = true;
      return;
    }
    if (empty) empty.hidden = true;
    if (foot) foot.hidden = false;

    list.innerHTML = cart.items.map((it) => `
      <div class="line-item" data-line-key="${it.key}">
        <div class="line-item__media">
          ${it.image ? `<img src="${it.image}" alt="${it.product_title}">` : ""}
        </div>
        <div>
          <div class="line-item__title">${it.product_title}</div>
          <div class="line-item__variant">${it.options_with_values ? it.options_with_values.map(o=>o.value).join("  /  ") : (it.variant_title||"")}</div>
          <div class="line-item__price">${money(it.final_price)}</div>
          <div class="line-item__ctrls">
            <div class="qty qty--sm">
              <button data-line-minus aria-label="Decrease">−</button>
              <input type="text" value="${it.quantity}" data-line-qty readonly>
              <button data-line-plus aria-label="Increase">+</button>
            </div>
            <button class="line-item__remove" data-line-remove>Remove</button>
          </div>
        </div>
      </div>`).join("");
  }

  /* ---------- AJAX add / change ---------- */
  async function addToCart(id, quantity) {
    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id, quantity }] }),
      });
      if (!res.ok) throw new Error();
      await refreshCart();
      openDrawer();
    } catch (_) {
      openDrawer(); // preview fallback
    }
  }

  async function changeLine(key, quantity) {
    try {
      const res = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity }),
      });
      const cart = await res.json();
      paintCart(cart);
    } catch (_) {}
  }

  document.addEventListener("click", (e) => {
    // Add-to-cart forms / buttons
    const addBtn = e.target.closest("[data-add-to-cart]");
    if (addBtn) {
      e.preventDefault();
      const id = addBtn.dataset.variantId || (addBtn.form && addBtn.form.querySelector('[name="id"]')?.value);
      const qtyInput = document.querySelector("[data-pdp-qty]");
      const qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      if (id) addToCart(id, qty);
      else openDrawer();
      return;
    }
    // Quick add from cards
    const quick = e.target.closest("[data-quick-add]");
    if (quick && quick.dataset.variantId) {
      e.preventDefault();
      addToCart(quick.dataset.variantId, 1);
    }
    // Upsell add
    const up = e.target.closest("[data-upsell-add]");
    if (up && up.dataset.variantId) { e.preventDefault(); addToCart(up.dataset.variantId, 1); }

    // Line item controls
    const item = e.target.closest("[data-line-key]");
    if (item) {
      const key = item.dataset.lineKey;
      const q = parseInt(item.querySelector("[data-line-qty]").value, 10);
      if (e.target.closest("[data-line-plus]")) changeLine(key, q + 1);
      if (e.target.closest("[data-line-minus]")) changeLine(key, Math.max(0, q - 1));
      if (e.target.closest("[data-line-remove]")) changeLine(key, 0);
    }
  });

  /* ---------- PDP: qty stepper ---------- */
  document.addEventListener("click", (e) => {
    const wrap = e.target.closest("[data-pdp-qty-wrap]");
    if (!wrap) return;
    const input = wrap.querySelector("[data-pdp-qty]");
    let v = parseInt(input.value, 10) || 1;
    if (e.target.closest("[data-qty-plus]")) input.value = v + 1;
    if (e.target.closest("[data-qty-minus]")) input.value = Math.max(1, v - 1);
  });

  /* ---------- PDP: variant option selection ---------- */
  const variantData = window.CC_VARIANTS || null;
  function selectedOptions() {
    const vals = [];
    document.querySelectorAll("[data-opt-group]").forEach((g) => {
      const active = g.querySelector("[data-opt].is-active");
      if (active) vals.push(active.dataset.opt);
    });
    return vals;
  }
  function syncVariant() {
    if (!variantData) return;
    const chosen = selectedOptions();
    const match = variantData.find((v) => v.options.every((o, i) => o === chosen[i]));
    const addBtn = document.querySelector("[data-add-to-cart]");
    const priceEl = document.querySelector("[data-pdp-price]");
    const btnPrice = document.querySelector("[data-btn-price]");
    if (match) {
      if (addBtn) { addBtn.dataset.variantId = match.id; }
      if (priceEl) priceEl.textContent = money(match.price);
      if (btnPrice) btnPrice.textContent = money(match.price);
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.querySelector("[data-btn-label]").textContent = match.available ? "Add to Cart" : "Sold Out";
      }
    }
  }
  document.addEventListener("click", (e) => {
    const opt = e.target.closest("[data-opt]");
    if (!opt) return;
    if (opt.disabled) return;
    const group = opt.closest("[data-opt-group]");
    group.querySelectorAll("[data-opt]").forEach((b) => b.classList.remove("is-active"));
    opt.classList.add("is-active");
    // update swatch label
    const lbl = group.querySelector("[data-opt-current]");
    if (lbl) lbl.textContent = opt.dataset.opt;
    syncVariant();
  });

  /* ---------- PDP: gallery thumbnails ---------- */
  document.addEventListener("click", (e) => {
    const thumb = e.target.closest("[data-gallery-thumb]");
    if (!thumb) return;
    const main = document.querySelector("[data-gallery-main]");
    if (main) main.src = thumb.dataset.full || thumb.querySelector("img").src;
    thumb.closest("[data-gallery]").querySelectorAll("[data-gallery-thumb]").forEach((t) => t.classList.remove("is-active"));
    thumb.classList.add("is-active");
  });

  /* ---------- Init ---------- */
  document.addEventListener("DOMContentLoaded", () => { refreshCart(); syncVariant(); });
})();
